import React, { useContext } from 'react';

import AlertsContext from 'common/contexts/alerts';
import Alert from './Alert';

const Alerts = () => {
  const { alerts, clearAlert } = useContext(AlertsContext);

  return (
    <section className={`${alerts.length > 0 && 'mt-2'} alerts`}>
      {alerts.length > 0 && alerts.map((alert) => (
        <Alert key={`${alert.id}`} alert={alert} clearAlert={clearAlert} />
      ))}
    </section>
  );
};

export default Alerts;
